(function () {
  angular.module('MktzapApp.Factories')
    .factory('NacWhiteListService', PdvService);

  PdvService.$inject = ['$resource'];

  function PdvService ($resource) {
    return $resource(apiUrl + '/channels-plugin/nac-white-list', {}, {
      store: { method: 'POST', params: {}, isArray: false },
      update: { method: 'PATCH', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      getWhiteListById: { method: 'GET', params: {}, isArray: false },
      getWhiteLists: { url: apiUrl + '/channels-plugin/nac-white-list/get-all', method: 'GET', params: {}, isArray: false },
      filterWhiteLists: { url: apiUrl + '/channels-plugin/nac-white-list/filter', method: 'GET', params: {}, isArray: false },
      getExistsCompanyCode: { url: apiUrl + '/channels-plugin/nac-white-list/get-exist/:companyCode', method: 'GET', params: {}, isArray: false }
    });
  }
})();
